/** Raised when a quantity cannot be measured against a given food. */
export class QuantityError extends Error {
    constructor(message) {
        super(message);
        this.name = 'QuantityError';
    }
}
/**
 * Converts a quantity into an amount in the food's own basis unit — grams for a
 * `per_100g` food, millilitres for a `per_100ml` one.
 *
 * Crossing between mass and volume uses the food's density (default 1.0), which
 * is why oils and milk carry an explicit density in the seed catalog.
 *
 * Throws when a countable quantity is used for a food that has no serving size,
 * because there is no honest way to guess what "1 piece" of it weighs.
 */
export function resolveBaseAmount(food, quantity) {
    const density = food.density ?? 1;
    const basisIsVolume = food.basis === 'per_100ml';
    switch (quantity.unit) {
        case 'g':
            return basisIsVolume ? quantity.amount / density : quantity.amount;
        case 'ml':
            return basisIsVolume ? quantity.amount : quantity.amount * density;
        case 'piece':
        case 'serving': {
            if (!food.serving) {
                throw new QuantityError(`"${food.name}" hat keine Portionsgröße und kann nicht in ${quantity.unit === 'piece' ? 'Stück' : 'Portionen'} erfasst werden. Erfasse es stattdessen nach Gewicht.`);
            }
            return food.serving.grams * quantity.amount;
        }
    }
}
/** Units that can be used for a food, given whether it has a serving size. */
export function availableUnits(food) {
    const units = ['g', 'ml'];
    if (food.serving)
        units.push('piece', 'serving');
    return units;
}
//# sourceMappingURL=quantity.js.map